<section class="d-flex align-items-stretch justify-content-center old-style">
    <div class="col-xs-12 col-sm-8 col-md-6 offset-sm-2 offset-md-0 d-flex">
      <div class="col-md-11 offset-md-1 col-lg-9 offset-lg-3 col-xl-8 offset-xl-4 d-flex align-items-center">
        <div class="mx-auto pb-5 mb-5">
          <a href="https://{{appVariables.WHITELABEL_LINK}}" class="pb-5">
            <img class="d-block logo" src="assets/img/{{appVariables.WHITELABEL_LOGO}}" alt="{{appVariables.WHITELABEL_BRAND}}"/>
          </a>

          <form [formGroup]="form" class="p-0 m-0 pt-5" name="signupForm" (ngSubmit)="submitting=true;signup()">
            <div *ngIf="step===0">
              <h1 class="mb-3 into white" *ngIf="planCode && planCode !== 'tablesready-free'">Start Your 14-Day Free Trial</h1>
              <h1 class="mb-3 into white" *ngIf="!planCode || planCode === 'tablesready-free'">Create Your Free Waitlist</h1>

              <div class="form-group">
                <input
                  id="signup-full-name"
                  type="text"
                  placeholder="full name"
                  formControlName="fullName"
                  class="form-control"
                  (blur)="onBlur()"
                  [class.is-invalid]="fullNameControl.touched && fullNameControl.invalid"
                />
                <control-messages [control]="fullNameControl"></control-messages>
              </div>

              <div class="form-group">
                <input
                  id="signup-email"
                  type="email"
                  placeholder="email"
                  formControlName="email"
                  autocomplete="email"
                  class="form-control"
                  (blur)="onBlur()"
                  oninput="this.value = this.value.toLowerCase().trim()"
                  [class.is-invalid]="emailControl.touched && emailControl.invalid"
                />
                <control-messages [control]="emailControl"></control-messages>
              </div>

              <div class="form-group">
                <input
                  id="signup-username"
                  type="text"
                  placeholder="username"
                  formControlName="username"
                  autocomplete="username"
                  class="form-control"
                  (blur)="onBlur()"
                  oninput="this.value = this.value.toLowerCase().trim()"
                  [class.is-invalid]="usernameControl.touched && usernameControl.invalid"
                />
                <control-messages [control]="usernameControl"></control-messages>
              </div>

              <div class="form-group password-input">
                <input
                  id="signup-password"
                  [type]="passwordType"
                  formControlName="newPassword"
                  placeholder="password"
                  autocomplete="off"
                  class="form-control"
                  minlength="4"
                  [class.is-invalid]="newPasswordControl.touched && newPasswordControl.invalid"
                />
                <control-messages [control]="newPasswordControl"></control-messages>
              </div>
              <button
                id="signup-next-button"
                class="btn btn-info btn-lg w-100 mb-2"
                (click)="step = 1"
                [disabled]="form.pristine || fullNameControl.invalid || newPasswordControl.invalid || usernameControl.invalid || emailControl.invalid"
                angularticsCategory="auth"
                angulartics2On="click"
                angularticsAction="Sign Up User Details"
              >Next</button>

              <div class="d-flex flex-nowrap white">
                Already have an account?&nbsp;
                <a
                  [routerLink]="[]"
                  (click)="goToLogin()"
                  angularticsCategory="auth"
                  angulartics2On="click"
                  angularticsAction="Log In Toggle"
                >Log in here</a>.
              </div>
            </div>

            <div *ngIf="step === 1">
              <h2 class="mb-3 white">Tell us a little about your business so we can personalize things</h2>
              <div class="form-group">
                <input
                  id="signup-name"
                  type="text"
                  formControlName="name"
                  placeholder="Business name"
                  autocomplete="organization"
                  class="form-control"
                  [class.is-invalid]="nameControl.touched && nameControl.invalid"
                />
                <control-messages [control]="nameControl"></control-messages>
              </div>

              <div class="form-group">
                <input
                  id="signup-phone"
                  type="tel"
                  formControlName="phoneNumber"
                  placeholder="Phone number"
                  autocomplete="tel"
                  class="form-control"
                  [class.is-invalid]="phoneNumberControl.touched && phoneNumberControl.invalid"
                />
                <control-messages [control]="phoneNumberControl"></control-messages>
              </div>

              <div class="form-group">
                <select id="signup-country" class="form-control" formControlName="country">
                  <option *ngFor="let country of countryOptions" [ngValue]="country">{{ country.name }}</option>
                </select>
                <control-messages [control]="countryControl"></control-messages>
              </div>

              <div class="form-group">
                <select
                  id="signup-industry"
                  formControlName="industry"
                  class="form-control"
                  autocomplete="off"
                  [ngClass]="{'is-invalid': countryControl.touched && countryControl.invalid }"
                >
                  <option [ngValue]="null" selected hidden disabled>Industry</option>
                  <option *ngFor="let industry of industries" [ngValue]="industry">{{ industry }}</option>
                </select>
                <control-messages [control]="industryControl"></control-messages>
              </div>

              <button
                id="signup-button"
                type="submit"
                class="btn btn-info btn-lg w-100 mb-2"
                [disabled]="form.invalid || form.pending || submitting"
                angularticsCategory="auth"
                angulartics2On="click"
                angularticsAction="Sign Up"
              >Create account</button>

              <div class="d-flex flex-nowrap justify-content-start">
                <a
                  id="previous"
                  [routerLink]="[]"
                  (click)="step = 0;"
                  angularticsCategory="auth"
                  angulartics2On="click"
                  angularticsAction="Step Back"
                >&lt;&lt; Previous</a>
                <a
                  [routerLink]="[]"
                  (click)="goToLogin()"
                  class="ml-auto"
                  angularticsCategory="auth"
                  angulartics2On="click"
                  angularticsAction="Log In Toggle"
                >Back to Login</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="d-none d-md-flex col-md-6 bg-secondary bg-curved">
      <div class="col-md-11 offset-md-1 col-lg-9 col-xl-8 d-flex align-items-center">
        <ul class="list-unstyled tr-icon-list white">
          <li class="mb-4">
            <div class="flex">
              <tr-icon [icon]="icon.check" [white]="true" classes="tr-bullet mr-1"></tr-icon>
              <h2 class="white">No credit card required</h2>
            </div>
            Try {{appVariables.WHITELABEL_BRAND}} 100% risk-free. No contracts, no games - just a waitlist & scheduling app.
          </li>
          <li class="mb-4">
            <div class="flex">
              <tr-icon [icon]="icon.check" [white]="true" classes="tr-bullet mr-1"></tr-icon>
              <h2 class="white">Get started quickly</h2>
            </div>
            Start adding guests to your waitlist in minutes!
          </li>
          <li>
            <div class="flex">
              <tr-icon [icon]="icon.check" [white]="true" classes="tr-bullet mr-1"></tr-icon>
              <h2 class="white">Join thousands of businesses</h2>
            </div>
            {{appVariables.WHITELABEL_BRAND}} is trusted by small restaurants and large Fortune 500 enterprises to delight their customers and streamline operations.
          </li>
        </ul>
      </div>
    </div>
</section>
